'use client';
import { FC, useEffect, useRef } from 'react';
import {
  cvaButton,
  cvaClose,
  cvaCloseIcon,
  cvaDescr,
  cvaEmoji,
  cvaEmojiImage,
  cvaInner,
  cvaOverlay,
  cvaRoot,
  cvaTitle,
} from './ReviewFormSuccessPopupStyles';
import { motion } from 'framer-motion';
import IconClose from '/public/icons/close.svg';
import Image from 'next/image';
import { Button } from '@/shared/ui/Button';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock-upgrade';

interface Props {
  onClose: () => void;
}

const ReviewFormSuccessPopup: FC<Props> = ({ onClose }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      disableBodyScroll(scrollRef.current, {
        reserveScrollBarGap: true,
      });
    }

    return () => {
      clearAllBodyScrollLocks();
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.3,
        ease: 'easeInOut',
      }}
      className={cvaRoot()}
      data-lenis-prevent
      ref={scrollRef}
    >
      <div className={cvaOverlay()} onClick={() => onClose()}></div>
      <div className={cvaInner()}>
        <button type="button" className={cvaClose()} onClick={() => onClose()}>
          <IconClose className={cvaCloseIcon()} />
        </button>
        <div className={cvaEmoji()}>
          <Image className={cvaEmojiImage()} src={'/icons/emoji.png'} fill alt="" />
        </div>
        <div className={cvaTitle()}>Спасибо за отзыв!</div>
        <div className={cvaDescr()}>Опубликуем его после проверки. Следите за статусом в разделе «Мои публикации»</div>
        <Button className={cvaButton()} color={'mediumGreen'} size={'medium'} onClick={() => onClose()}>
          Отлично
        </Button>
      </div>
    </motion.div>
  );
};

export default ReviewFormSuccessPopup;
